export const version = '2.9.5';
//# sourceMappingURL=version.js.map